import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
import boostedMultibet from "./modules/boosted-multibet";
import settings from "./modules/settings";
import casino from "./modules/casino";
import cashout from "./modules/cashout";
import virtuals from "./modules/virtuals";
import weeklyJackpot from "./modules/weekly-jackpot";
import mustBeWonJackpot from "./modules/must-be-won-jackpot";
import dataNotifier from "./modules/data-notifier";
import freebets from "./modules/free-bets";
import recommendations from "./modules/recommendations";
import favouriteMarkets from "./modules/favourite-markets";
import navigation from "./modules/navigation";
import productTour from "./modules/product-tour";
import growthbook from "./modules/growthbook";
import promos from "./modules/promos";
import axios from "axios";
import analytics from "../utils/analytics";
import bets from "./modules/bets";
import affiliates from "./modules/affiliates";
import meta from "./modules/meta";
import analyticsPlugin from "../utils/eventAnalytics/plugin";
import { zonedTimeToUtc } from "date-fns-tz";
import { parse } from "date-fns";
import config from "../config/config";

Vue.use(Vuex);
Vue.use(VueResource);

const SELECTED_SPORT_KEY = "selected-sport";
const selectedSportKey = localStorage.getItem(SELECTED_SPORT_KEY);

const env = config[process.env.COUNTRY_CODE] ? config[process.env.COUNTRY_CODE] : config;

const betterTimeMilliseconds = (sometime) => {
	const parsedDate = parse(sometime, "yyyy-MM-dd HH:mm:ss", new Date());
	let dbTime = zonedTimeToUtc(parsedDate, window.DB_TIMEZONE);
	return dbTime.getTime();
}

const store = new Vuex.Store({
	modules: {
		boostedMultibet,
		settings,
		weeklyJackpot,
		mustBeWonJackpot,
		virtuals,
		dataNotifier,
		freebets,
		casino,
		cashout,
		recommendations,
		favouriteMarkets,
		navigation,
		productTour,
		affiliates,
		promos,
		bets,
		meta,
		growthbook,
	},
	state: {
		betSlip: JSON.parse(localStorage.getItem("betSlip"))
			? JSON.parse(localStorage.getItem("betSlip"))
			: [],

		boostedBetSlip: JSON.parse(localStorage.getItem("boostedBetSlip"))
			? JSON.parse(localStorage.getItem("boostedBetSlip"))
			: [],

		virtualBetslip: JSON.parse(localStorage.getItem("virtualBetslip"))
			? JSON.parse(localStorage.getItem("virtualBetslip"))
			: [],

		jengabetBetSlip: JSON.parse(localStorage.getItem("jengabetBetSlip"))
			? JSON.parse(localStorage.getItem("jengabetBetSlip"))
			: [],
		jackpot: JSON.parse(sessionStorage.getItem("jackpot"))
			? JSON.parse(sessionStorage.getItem("jackpot"))
			: [],
		jackpot20M: JSON.parse(sessionStorage.getItem("jackpot20M"))
			? JSON.parse(sessionStorage.getItem("jackpot20M"))
			: [],
		utm: JSON.parse(localStorage.getItem("utm_info"))
			? JSON.parse(localStorage.getItem("utm_info"))
			: null,
		freeJackpot: [],
		jackpotEvents: [],
		jackpotEventsLoaded: false,
		matches: [],
		liveMatches: [],
		context: "",
		stake: null,
		boostedStake: 100,
		snackBar: {
			show: false,
			messages: [""],
		},
		search: {
			show: false,
		},
		authenticated: localStorage["authenticated"]
			? JSON.parse(localStorage["authenticated"])
			: false,
		user: JSON.parse(localStorage.getItem("user"))
			? JSON.parse(localStorage.getItem("user"))
			: {},
		token: JSON.parse(localStorage.getItem("token"))
			? JSON.parse(localStorage.getItem("token"))
			: null,
		balance: 0,
		numberOfLiveMatches: 0,
		headerHidden: false,
		platformSettings: localStorage["betika-platform-settings"]
			? JSON.parse(localStorage["betika-platform-settings"])
			: null,
		currentTermsCategoryId: 1,
		currentTermsCategoryTitle: "terms-and-conditions",
		currentTermsSubCategoryId: "1.1",
		currentTermsSubCategoryTitle: "introduction",
		currentTermsMiniCategoryId: "",
		currentTermsMiniCategoryTitle: "",
		legalData: "",
		isAndroid: false,
		authActions: [],
		layout: "Mobile",
		sports: [],
		sportsLoaded: false,
		selectedSport:
			selectedSportKey &&
			selectedSportKey !== "undefined" &&
			selectedSportKey !== "null"
				? JSON.parse(selectedSportKey)
				: null,
		selectedNav: "",
		competitions: [],
		competitionsLoaded: false,
		selectedCompetition: {
			competition_id: null,
			competition_name: null,
		},
		countries: [],
		countriesLoaded: false,
		liveMatchesLoaded: false,
		liveSelectedSport: null,
		liveSports: [],
		liveSportsLoaded: false,
		bethistoryFilters: {
			product: "",
			period: "",
		},
		transactionFilters: {
			period: "",
		},
		mybetsLastFetchTimeStamp: null,
		countryConfigsLoaded: null,
		ipCheckStatus: false,
		kycData: [],
		seoContentBlock: [],
		affiliatesVisibility: false,
		metaContentBlock: [],
		ga4AnalyticsEventConfig: {},
		utmSource: null,
	},
	mutations: {
		SET_IP_CHECK_STATUS(state, status) {
			state.ipCheckStatus = status;
		},
		SET_COUNTRY_CONFIGS_LOADED_STATUS(state, status) {
			state.countryConfigsLoaded = status;
		},
		SET_MYBETS_LAST_FETCH_TIME(state, time) {
			state.mybetsLastFetchTimeStamp = time;
		},
		SET_BET_HISTORY_FILTERS(state, filters) {
			state.bethistoryFilters = filters;
		},
		SET_TRANSACTION_FILTERS(state, filters) {
			state.transactionFilters = filters;
		},
		SET_LIVE_MATCHES(state, matches) {
			state.liveMatches = matches;
			state.liveMatchesLoaded = true;
		},
		UPDATE_LIVE_SPORTS(state, sports) {
			state.liveSports = sports;
		},
		UPDATE_LIVE_SPORTS_LOADED(state, status) {
			state.liveSportsLoaded = status;
		},
		UPDATE_LIVE_SELECTED_SPORT(state, sport) {
			state.liveSelectedSport = sport;
		},
		UPDATE_LIVE_MATCHES_LOADED(state, status) {
			state.liveMatchesLoaded = status;
		},
		UPDATE_SELECTED_NAV(state, nav) {
			state.selectedNav = nav;
		},
		UPDATE_SELECTED_COMPETITION(state, competition) {
			state.selectedCompetition = competition;
		},
		SET_COUNTRIES(state, countries) {
			state.countries = countries;
			state.countriesLoaded = true;
		},
		UPDATE_SELECTED_SPORT(state, sport) {
			state.selectedSport = sport;
			localStorage.setItem(SELECTED_SPORT_KEY, JSON.stringify(sport));
		},
		SET_SPORTS(state, sports) {
			state.sports = sports;
			state.sportsLoaded = true;
		},
		CHANGE_LAYOUT(state, layout) {
			state.layout = layout;
		},
		addToAuthActions(state, action) {
			this.state.authActions.push(action);
		},
		setNumberOfLiveMatches(state, number) {
			state.numberOfLiveMatches = number;
		},
		setBalance(state, balance) {
			state.balance = balance;
			let user = state.user;
			if (!user || !user.id) return;
			user.balance = balance;
			localStorage.user = JSON.stringify(user);
		},
		setAuthenticated(state, status) {
			state.authenticated = status;
			localStorage.authenticated = JSON.stringify(status);
		},
		setUser(state, user) {
			state.user = user;
		},
		setToken(state, token) {
			state.token = token;
		},
		setKyc(state, hasKyc) {
			state.user.has_kyc = hasKyc;
		},
		SET_KYC_DATA(state, kycData) {
			state.kycData = kycData;
		},
		updateUserSettings(state, settings) {
			console.log("[STORE] Update user settings", settings);
			localStorage["betika-platform-settings"] = JSON.stringify(settings);
			state.platformSettings = settings;
		},
		updateStake(state, stake) {
			state.stake = stake;
		},
		updateBoostedStake(state, stake) {
			state.boostedStake = stake;
		},
		addToBetslip(state, bet) {
			if (!navigator.onLine) {
				state.snackBar = {
					show: true,
					messages: ["Please get back online to add to your betslip"],
					status: "error",
				};
				setTimeout(() => {
					state.snackBar = {
						show: false,
						messages: [""],
					};
				}, 5000);
				return;
			}
			if (state.betSlip.length > 39) {
				state.snackBar = {
					show: true,
					messages: ["Maximum number of bets reached (40)"],
					status: "warning",
				};
				setTimeout(() => {
					state.snackBar = {
						show: false,
						messages: [""],
					};
				}, 5000);
			} else {
				const coolaPayload = {
					profile_id: bet.profile_id,
					app_name: bet.app_name,
					parent_match_id: bet.parent_match_id,
					game_description: bet.game_description,
					bet_pick: bet.bet_pick,
					sub_type_id: bet.sub_type_id,
					market_name: bet.market,
					odd_key: bet.odd_key,
					odd_value: bet.odd_value,
					special_bet_value: bet.special_bet_value,
					bet_type: bet.bet_type,
					home_team: bet.home_team,
					away_team: bet.away_team,
					provider:bet.provider
				};
				analyticsPlugin.betSlip.add({
					appName: bet.app_name,
					betType: bet.bet_type,
					display: `${bet.home_team} vs. ${bet.away_team}`,
					matchId: bet.parent_match_id,
					profileId: window.localStorage.getItem("user")
						? JSON.parse(window.localStorage.getItem("user")).id
						: "",
					betPick: bet.bet_pick,
					homeTeam: bet.home_team,
					awayTeam: bet.away_team,
					oddValue: bet.odd_value,
					market: bet.market,
					startTime: bet.startTime,
				});
				state.betSlip.push(bet);
				localStorage.setItem("betSlip", JSON.stringify(state.betSlip));
			}
		},
		addToBoostedBetslip(state, bet) {
			if (!navigator.onLine) {
				state.snackBar = {
					show: true,
					messages: ["Please get back online to add to your betslip"],
					status: "error",
				};
				setTimeout(() => {
					state.snackBar = {
						show: false,
						messages: [""],
					};
				}, 5000);
				return;
			}
			if (state.boostedBetSlip.length > 29) {
				state.snackBar = {
					show: true,
					messages: ["Maximum number of bets reached (30)"],
					status: "warning",
				};
				setTimeout(() => {
					state.snackBar = {
						show: false,
						messages: [""],
					};
				}, 5000);
			} else {
				const coolaPayload = {
					profile_id: bet.profile_id,
					app_name: bet.app_name,
					parent_match_id: bet.parent_match_id,
					game_description: bet.game_description,
					bet_pick: bet.bet_pick,
					sub_type_id: bet.sub_type_id,
					market_name: bet.market,
					odd_key: bet.odd_key,
					odd_value: bet.odd_value,
					special_bet_value: bet.special_bet_value,
					bet_type: bet.bet_type,
					home_team: bet.home_team,
					away_team: bet.away_team,
				};
				analyticsPlugin.betSlip.add({
					appName: bet.app_name,
					betType: bet.bet_type,
					display: bet.display,
					matchId: bet.matchId,
					profileId: window.localStorage.getItem("user")
						? JSON.parse(window.localStorage.getItem("user")).id
						: "",
					betPick: bet.bet_pick,
					homeTeam: bet.home_team,
					awayTeam: bet.away_team,
					oddValue: bet.odd_value,
					market: bet.market,
					startTime: bet.startTime,
				});
				state.boostedBetSlip.push(bet);
				localStorage.setItem(
					"boostedBetSlip",
					JSON.stringify(state.boostedBetSlip)
				);
			}
		},
		addToJengabetBetslip(state, bet) {
			if (!navigator.onLine) {
				state.snackBar = {
					show: true,
					messages: ["Please get back online to add to your betslip"],
					status: "error",
				};
				setTimeout(() => {
					state.snackBar = {
						show: false,
						messages: [""],
					};
				}, 5000);
				return;
			}
			if (state.betSlip.length > 29) {
				state.snackBar = {
					show: true,
					messages: ["Maximum number of bets reached (30)"],
					status: "warning",
				};
				setTimeout(() => {
					state.snackBar = {
						show: false,
						messages: [""],
					};
				}, 5000);
			} else {
				const coolaPayload = {
					parent_match_id: bet.parent_match_id,
					game_description: bet.game_description,
					bet_pick: bet.bet_pick,
					sub_type_id: bet.sub_type_id,
					market_name: bet.market,
					odd_key: bet.odd_key,
					odd_value: bet.odd_value,
					special_bet_value: bet.special_bet_value,
					bet_type: bet.bet_type,
					home_team: bet.home_team,
					away_team: bet.away_team,
				};
				state.jengabetBetSlip.push(bet);
				localStorage.setItem(
					"jengabetBetSlip",
					JSON.stringify(state.jengabetBetSlip)
				);
			}
			analyticsPlugin.betSlip.add({
				appName: bet.app_name,
				betType: bet.bet_type,
				display: bet.display,
				matchId: bet.matchId,
				profileId: window.localStorage.getItem("user")
					? JSON.parse(window.localStorage.getItem("user")).id
					: "",
				betPick: bet.bet_pick,
				homeTeam: bet.home_team,
				awayTeam: bet.away_team,
				oddValue: bet.odd_value,
				market: bet.market,
				startTime: bet.startTime,
			});
		},
		removeFromBetslip(state, betToRemove) {
			const coolaPayload = {
				profile_id: betToRemove.profile_id,
				app_name: betToRemove.app_name,
				parent_match_id: betToRemove.parent_match_id,
				game_description: betToRemove.game_description,
				bet_pick: betToRemove.bet_pick,
				sub_type_id: betToRemove.sub_type_id,
				market_name: betToRemove.market,
				odd_key: betToRemove.odd_key,
				odd_value: betToRemove.odd_value,
				special_bet_value: betToRemove.special_bet_value,
				bet_type: betToRemove.bet_type,
				home_team: betToRemove.home_team,
				away_team: betToRemove.away_team,
				provider:betToRemove.provider
			};

			analyticsPlugin.betSlip.remove({
				appName: betToRemove.app_name,
				betType: betToRemove.bet_type,
				display: `${betToRemove.home_team} vs. ${betToRemove.away_team}`,
				matchId: betToRemove.parent_match_id,
				profileId: window.localStorage.getItem("user")
					? JSON.parse(window.localStorage.getItem("user")).id
					: "",
				betPick: betToRemove.bet_pick,
				homeTeam: betToRemove.home_team,
				awayTeam: betToRemove.away_team,
				oddValue: betToRemove.odd_value,
				market: betToRemove.market,
				startTime: betToRemove.startTime,
			});
			state.betSlip = state.betSlip.filter(function (bet) {
				return bet.matchId != betToRemove.matchId;
			});
			localStorage.setItem("betSlip", JSON.stringify(state.betSlip));
			localStorage.setItem("betSlip-has-recommendations", false);
		},
		removeFromBoostedBetslip(state, betToRemove) {
			const coolaPayload = {
				profile_id: betToRemove.profile_id,
				app_name: betToRemove.app_name,
				parent_match_id: betToRemove.parent_match_id,
				game_description: betToRemove.game_description,
				bet_pick: betToRemove.bet_pick,
				sub_type_id: betToRemove.sub_type_id,
				market_name: betToRemove.market,
				odd_key: betToRemove.odd_key,
				odd_value: betToRemove.odd_value,
				special_bet_value: betToRemove.special_bet_value,
				bet_type: betToRemove.bet_type,
				home_team: betToRemove.home_team,
				away_team: betToRemove.away_team,
			};
			analyticsPlugin.betSlip.remove({
				appName: betToRemove.app_name,
				betType: betToRemove.bet_type,
				display: `${betToRemove.home_team} vs. ${betToRemove.away_team}`,
				matchId: betToRemove.parent_match_id,
				profileId: window.localStorage.getItem("user")
					? JSON.parse(window.localStorage.getItem("user")).id
					: "",
				betPick: betToRemove.bet_pick,
				homeTeam: betToRemove.home_team,
				awayTeam: betToRemove.away_team,
				oddValue: betToRemove.odd_value,
				market: betToRemove.market,
				startTime: betToRemove.startTime,
			});
			state.boostedBetSlip = state.boostedBetSlip.filter(function (bet) {
				return bet.matchId != betToRemove.matchId;
			});
			localStorage.setItem(
				"boostedBetSlip",
				JSON.stringify(state.boostedBetSlip)
			);
		},
		removeFromJengabetBetslip(state, betToRemove) {
			const coolaPayload = {
				profile_id: betToRemove.profile_id,
				app_name: betToRemove.app_name,
				parent_match_id: betToRemove.parent_match_id,
				game_description: betToRemove.game_description,
				bet_pick: betToRemove.bet_pick,
				sub_type_id: betToRemove.sub_type_id,
				market_name: betToRemove.market,
				odd_key: betToRemove.odd_key,
				odd_value: betToRemove.odd_value,
				special_bet_value: betToRemove.special_bet_value,
				bet_type: betToRemove.bet_type,
				home_team: betToRemove.home_team,
				away_team: betToRemove.away_team,
			};
			state.jengabetBetSlip = state.jengabetBetSlip.filter(function (bet) {
				return (
					bet.matchId != betToRemove.matchId || bet.market != betToRemove.market
				);
			});
			localStorage.setItem(
				"jengabetBetSlip",
				JSON.stringify(state.jengabetBetSlip)
			);
		},
		removeMarketFromJengabetBetslip(state, betToRemove) {
			const coolaPayload = {
				profile_id: betToRemove.profile_id,
				app_name: betToRemove.app_name,
				parent_match_id: betToRemove.parent_match_id,
				game_description: betToRemove.game_description,
				bet_pick: betToRemove.bet_pick,
				sub_type_id: betToRemove.sub_type_id,
				market_name: betToRemove.market,
				odd_key: betToRemove.odd_key,
				odd_value: betToRemove.odd_value,
				special_bet_value: betToRemove.special_bet_value,
				bet_type: betToRemove.bet_type,
				home_team: betToRemove.home_team,
				away_team: betToRemove.away_team,
			};
			state.jengabetBetSlip = state.jengabetBetSlip.filter(function (bet) {
				if (bet.parent_match_id == betToRemove.parent_match_id) {
					return bet.type != betToRemove.type;
				} else {
					return true;
				}
			});
			localStorage.setItem(
				"jengabetBetSlip",
				JSON.stringify(state.jengabetBetSlip)
			);
		},
		replaceBetInBetslip(state, newBet) {
			// get index of bet
			let betIndex = state.betSlip.findIndex(function (bet) {
				return bet.matchId == newBet.matchId;
			});
			// slot in the new bet
			state.betSlip.splice(betIndex, 1, newBet);
			// persist
			localStorage.setItem("betSlip", JSON.stringify(state.betSlip));
		},
		removeInvalidMatches(state) {
			state.betSlip = state.betSlip.filter(function (bet) {
				// return (
				//   bet.status != "STOPPED" && Number(bet.odd.odd_value) && bet.active
				// );
				return (
					bet.status != "STOPPED" &&
					Number(bet.odd.odd_value) &&
					(bet.live
						? bet.active
						: betterTimeMilliseconds(bet.startTime) > +new Date())
				);
			});
			localStorage.setItem("betSlip", JSON.stringify(state.betSlip));
		},
		replaceBetslip(state, newBetslip) {
			state.betSlip = newBetslip;
		},
		clearBetslip(state) {
			let coolaPayload = [];
			state.betSlip.forEach((bet) => {
				const tempPayload = {
					parent_match_id: bet.parent_match_id,
					game_description: bet.game_description,
					bet_pick: bet.bet_pick,
					sub_type_id: bet.sub_type_id,
					market_name: bet.market,
					odd_key: bet.odd_key,
					odd_value: bet.odd_value,
					special_bet_value: bet.special_bet_value,
					bet_type: bet.bet_type,
					home_team: bet.home_team,
					away_team: bet.away_team,
					provider:bet.provider
				};
				coolaPayload.push(tempPayload);
			});
			coolaPayload = { array_of_bets: coolaPayload };
			state.betSlip = [];
			localStorage.setItem("betSlip", JSON.stringify(state.betSlip));
		},
		clearBoostedBetslip(state) {
			let coolaPayload = [];
			state.boostedBetSlip.forEach((bet) => {
				const tempPayload = {
					parent_match_id: bet.parent_match_id,
					game_description: bet.game_description,
					bet_pick: bet.bet_pick,
					sub_type_id: bet.sub_type_id,
					market_name: bet.market,
					odd_key: bet.odd_key,
					odd_value: bet.odd_value,
					special_bet_value: bet.special_bet_value,
					bet_type: bet.bet_type,
					home_team: bet.home_team,
					away_team: bet.away_team,
					provider:bet.provider
				};
				coolaPayload.push(tempPayload);
			});
			coolaPayload = { array_of_bets: coolaPayload };
			state.boostedBetSlip = [];
			localStorage.setItem(
				"boostedBetSlip",
				JSON.stringify(state.boostedBetSlip)
			);
		},
		clearJengabetBetslip(state) {
			let coolaPayload = [];
			state.jengabetBetSlip.forEach((bet) => {
				const tempPayload = {
					parent_match_id: bet.parent_match_id,
					game_description: bet.game_description,
					bet_pick: bet.bet_pick,
					sub_type_id: bet.sub_type_id,
					market_name: bet.market,
					odd_key: bet.odd_key,
					odd_value: bet.odd_value,
					special_bet_value: bet.special_bet_value,
					bet_type: bet.bet_type,
					home_team: bet.home_team,
					away_team: bet.away_team,
				};
				coolaPayload.push(tempPayload);
			});
			coolaPayload = { array_of_bets: coolaPayload };
			state.jengabetBetSlip = [];
			localStorage.setItem(
				"jengabetBetSlip",
				JSON.stringify(state.jengabetBetSlip)
			);
		},
		GET_MATCHES(state, matches) {
			state.matches = matches.data;
		},
		getLiveMatches(state, context) {
			state.context = context;
			Vue.http
				.get(LIVE_URL + context + "/")
				.then(function (data) {
					state.liveMatches = data.body;
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		addToJackpot(state, bet) {
			if (state.jackpot.length == 13) {
				state.snackBar = {
					show: true,
					messages: [
						"You can only select outcomes for a maximum of 13 matches",
					],
					status: "warning",
				};
				window.setTimeout(() => {
					state.snackBar = {
						show: false,
						messages: [""],
					};
				}, 3000);
				return;
			}
			state.jackpot.push(bet);
			sessionStorage.setItem("jackpot", JSON.stringify(state.jackpot));
		},
		removeFromJackpot(state, betToRemove) {
			state.jackpot = state.jackpot.filter(function (bet) {
				return bet.matchId != betToRemove.matchId;
			});
			sessionStorage.setItem("jackpot", JSON.stringify(state.jackpot));
		},
		clearJackpot(state, type) {
			state.jackpot = state.jackpot.filter((bet) => {
				return bet.type != type;
			});
			sessionStorage.setItem("jackpot", JSON.stringify(state.jackpot));
		},
		addTo20MJackpot(state, bet) {
			if (state.jackpot20M.length == 17) {
				state.snackBar = {
					show: true,
					messages: [
						"You can only select outcomes for a maximum of 17 matches",
					],
					status: "warning",
				};
				window.setTimeout(() => {
					state.snackBar = {
						show: false,
						messages: [""],
					};
				}, 3000);
				return;
			}
			state.jackpot20M.push(bet);
			sessionStorage.setItem("jackpot20M", JSON.stringify(state.jackpot20M));
		},
		setUtmInfo(state, utmInfo) {
			state.utm = utmInfo;
			localStorage.setItem("utm_info", JSON.stringify(state.utm));
		},
		removeFrom20MJackpot(state, betToRemove) {
			state.jackpot20M = state.jackpot20M.filter(function (bet) {
				return bet.matchId != betToRemove.matchId;
			});
			sessionStorage.setItem("jackpot20M", JSON.stringify(state.jackpot20M));
		},
		clear20MJackpot(state, type) {
			state.jackpot20M = [];
			sessionStorage.setItem("jackpot20M", JSON.stringify(state.jackpot20M));
		},
		addToFreeJackpot(state, bet) {
			state.freeJackpot.push(bet);
		},
		removeFromFreeJackpot(state, betToRemove) {
			state.freeJackpot = state.freeJackpot.filter(function (bet) {
				return bet.matchId != betToRemove.matchId;
			});
		},
		clearFreeJackpot(state, type) {
			state.freeJackpot = state.freeJackpot.filter((bet) => {
				return bet.type != type;
			});
		},
		setJackpotEvents(state, events) {
			state.jackpotEvents = events;
		},
		setJackpotEventsStatus(state, status) {
			state.jackpotEventsLoaded = status;
		},
		toggleSnackBar(state, newState) {
			state.snackBar = newState;
		},
		toggleSearch(state) {
			state.search.show
				? (state.search.show = false)
				: (state.search.show = true);
		},
		openSearch(state) {
			state.search.show = true;
		},
		closeSearch(state) {
			state.search.show = false;
		},
		hideHeader(state) {
			state.headerHidden = true;
		},
		showHeader(state) {
			state.headerHidden = false;
		},
		logout(state) {
			localStorage.removeItem("user");
			localStorage.removeItem("token");
			localStorage.removeItem("affiliateID");
			localStorage.removeItem("affiliateTag");
			localStorage.removeItem("token");
			localStorage.removeItem("utm_info");
			localStorage.setItem("authenticated", false);
			state.user = {};
			state.authenticated = false;
		},
		addToVirtualBetslip(state, bet) {
			state.virtualBetslip.push(bet);
			localStorage.setItem(
				"virtualBetslip",
				JSON.stringify(state.virtualBetslip)
			);
		},
		removeFromVirtualBetslip(state, parent_virtual_id) {
			state.virtualBetslip = state.virtualBetslip.filter(function (bet) {
				return bet.parent_virtual_id != parent_virtual_id;
			});
			localStorage.setItem(
				"virtualBetslip",
				JSON.stringify(state.virtualBetslip)
			);
		},
		removeInvalidBetsFromVirtualBetslip(state) {
			state.virtualBetslip = state.virtualBetslip.filter((bet) => {
				return +new Date(bet.start_time.replace(/-/g, "/")) > +new Date();
			});
			localStorage.setItem(
				"virtualBetslip",
				JSON.stringify(state.virtualBetslip)
			);
		},
		clearVirtualBetslip(state, bet) {
			state.virtualBetslip = [];
			localStorage.setItem(
				"virtualBetslip",
				JSON.stringify(state.virtualBetslip)
			);
		},
		setCurrentTermsCategoryId(state, categoryId) {
			state.currentTermsCategoryId = categoryId;
		},
		setCurrentTermsCategoryTitle(state, categoryTitle) {
			state.currentTermsCategoryTitle = categoryTitle;
		},
		setCurrentTermsSubCategoryId(state, subCategoryId) {
			state.currentTermsSubCategoryId = subCategoryId;
		},
		setCurrentTermsSubCategoryTitle(state, subCategoryTitle) {
			state.currentTermsSubCategoryTitle = subCategoryTitle;
		},
		setCurrentTermsMiniCategoryId(state, miniCategoryId) {
			state.currentTermsMiniCategoryId = miniCategoryId;
		},
		setCurrentTermsMiniCategoryTitle(state, miniCategoryTitle) {
			state.currentTermsMiniCategoryTitle = miniCategoryTitle;
		},
		setLegal(state, payload) {
			state.legalData = payload;
		},
		setAndroid(state, payload) {
			state.isAndroid = payload;
		},
		setSeoContentBlock(state, payload) {
			state.seoContentBlock = payload;
		},
		setMetaBlock(state, payload) {
			state.metaContentBlock = payload;
		},
		setVirtualGamesParams(state, queryParams) {
			state.queryParams = queryParams;
		},
		setAffiliatesModalVisibility(state, visibility) {
			state.affiliatesVisibility = visibility;
		},
		setGA4EventConfig(state, payload) {
			state.ga4AnalyticsEventConfig = payload;
		},
		setUtmSource(state, utmSource) {
			state.utmSource = utmSource;
		},
	},
	actions: {
		updateUtmSource({ commit }, utmSource) {
			commit("setUtmSource", utmSource);
		},
		getGA4EventConfigData({ commit }) {
			return new Promise((resolve, reject) => {
				axios.get(`${GA4_ANALYTICS_Event_CONFIG_URL}`).then(
					(response) => {
						commit("setGA4EventConfig", response.data);
					},
					(error) => {
						resolve(error);
					}
				);
			});
		},
		getCountries({ commit, state }) {
			let sportIds = null

			if (state.selectedSport) {
				const sportId = state.selectedSport.sport_id
				const mappings = env.zoomSportMappings

				sportIds = sportId

				if (mappings && mappings.includeRelated && mappings.sport_ids && mappings.sport_ids[sportId]) {
					sportIds = Object.values(mappings.sport_ids[sportId]).join(',')
				}
			}
			let params = {
				page: 1,
				limit: 1000,
				id:sportIds,
			};
			return new Promise((resolve, reject) => {
				axios
					.get(`${BASE_URL}uo/sport`, { params })
					.then((res) => {
						let countries = res.data;
						let filteredCountries = countries.data.map((country) => {
							country.competitions.map((competition) => {
								competition.urlSlug = `${country.category_name
									.split(" ")
									.join("-")
									.toLowerCase()}-${competition.competition_name
									.split(" ")
									.join("-")
									.toLowerCase()
									.replace(/,/g, "")}`;
								return competition;
							});
							return country;
						});
						countries.data = filteredCountries;
						resolve(countries);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		getSports({ commit }) {
			return new Promise((resolve, reject) => {
				axios
					.get(`${BASE_URL}sports`)
					.then((res) => {
						resolve(res.data.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		getLegal({ commit }) {
			return new Promise((resolve, reject) => {
				axios.get(`${LEGAL_DATA}`).then(
					(response) => {
						commit("setLegal", response.data);
					},
					(error) => {
						resolve(error);
					}
				);
			});
		},
		getJackpotEvents({ commit }) {
			return new Promise((resolve, reject) => {
				commit("setJackpotEventsStatus", false);
				axios.get(`${BASE_URL}jackpot/events`).then(
					(response) => {
						commit("setJackpotEvents", response.data);
						commit("setJackpotEventsStatus", true);
						resolve(response.data);
					},
					(error) => {
						resolve(error);
					}
				);
			});
		},
		trackOperaId({ commit }, payload) {
			// send data to campaigns endpoint
			const operaId = payload;
			if (!operaId) return;
			axios({
				method: "post",
				url: `${window.CAMPAIGN_URL}/hoid`,
				data: {
					profile_id: JSON.parse(window.localStorage.getItem("user"))
						? parseInt(JSON.parse(window.localStorage.getItem("user")).id)
						: 0,
					platform_id: 1,
					hoid: operaId,
				},
			});
		},
		getSeoContentBlock({ commit }) {
			return new Promise((resolve, reject) => {
				axios.get(`${SEO_CONTENT_BLOCK_DATA}`).then(
					(response) => {
						commit("setSeoContentBlock", response.data);
					},
					(error) => {
						resolve(error);
					}
				);
			});
		},
		getMetaDataContent({ commit }) {
			return new Promise((resolve, reject) => {
				axios.get(`${WEBSITE_META_DATA}`).then(
					(response) => {
						commit("setMetaBlock", response.data);
					},
					(error) => {
						resolve(error);
					}
				);
			});
		},
	},
	getters: {
		ipCheckStatus(state) {
			return state.ipCheckStatus;
		},
		countryConfigsLoaded(state) {
			return state.countryConfigsLoaded;
		},
		kycData(state) {
			return state.kycData;
		},
		mybetsLastFetchTimeStamp(state) {
			return state.mybetsLastFetchTimeStamp;
		},
		bethistoryFilters(state) {
			return state.bethistoryFilters;
		},
		transactionFilters(state) {
			return state.transactionFilters;
		},
		liveMatchesLoaded(state) {
			return state.liveMatchesLoaded;
		},
		liveMatches(state) {
			return state.liveMatches;
		},
		liveSelectedSport(state) {
			return state.liveSelectedSport;
		},
		liveSportsLoaded(state) {
			return state.liveSportsLoaded;
		},
		liveSports(state) {
			return state.liveSports;
		},
		selectedCompetition(state) {
			return state.selectedCompetition;
		},
		selectedNav(state) {
			return state.selectedNav;
		},
		selectedSport(state) {
			return state.selectedSport ? state.selectedSport : null;
		},
		countries(state) {
			return state.countries;
		},
		countriesLoaded(state) {
			return state.countriesLoaded;
		},
		sports(state) {
			return state.sports;
		},
		sportsLoaded(state) {
			return state.sportsLoaded;
		},
		layout(state) {
			return state.layout;
		},
		authActions(state) {
			return state.authActions;
		},
		virtualBetslip(state) {
			return state.virtualBetslip;
		},
		virtualBetslipCount(state) {
			return state.virtualBetslip.length;
		},
		numberOfLiveMatches(state) {
			return state.numberOfLiveMatches;
		},
		betSlipCount: (state) => {
			return state.betSlip.length;
		},
		jengabetBetSlipCount: (state) => {
			return state.jengabetBetSlip.length;
		},
		betSlip: (state) => {
			return state.betSlip;
		},
		boostedBetSlip: (state) => {
			return state.boostedBetSlip;
		},
		boostedBetslipCount: (state) => {
			return state.boostedBetSlip.length;
		},
		stake(state) {
			return state.stake;
		},
		boostedStake(state) {
			return state.boostedStake;
		},
		platformSettings(state) {
			return state.platformSettings;
		},
		jengabetBetSlip(state) {
			return state.jengabetBetSlip;
		},
		selectedBets: (state) => {
			return state.betSlip.map((bet) => bet.matchId);
		},
		grandJackpot(state) {
			return state.jackpotEvents.filter((event) => {
				return event.product_id == 8;
			});
		},
		midweekJackpot(state) {
			return state.jackpotEvents.filter((event) => {
				return event.product_id == 6;
			});
		},
		mustBeWonJackpot: (state) => (productId) => {
			// Filter by jackpot ID passed from config (13 on prod, 22 on dev)
			return state.jackpotEvents.filter((event) => {
				return event.product_id == productId;
			});
		},
		jackpotEvents(state) {
			return state.jackpotEvents;
		},
		jackpotEventsLoaded(state) {
			return state.jackpotEventsLoaded;
		},
		jackpotLength: (state) => {
			return state.jackpot.filter((bet) => {
				return bet.type == 12;
			}).length;
		},
		jackpot20MLength: (state) => {
			return state.jackpot20M.filter((bet) => {
				return bet.type == 17;
			}).length;
		},
		bingwaLength: (state) => {
			return state.jackpot.filter((bet) => {
				return bet.type == 5;
			}).length;
		},
		utmInfo: (state) => {
			return state.utm;
		},
		snackBar: (state) => {
			return state.snackBar;
		},
		authenticated(state) {
			return state.authenticated;
		},
		user(state) {
			return state.user;
		},
		auth(state) {
			return { user: state.user, token: state.token };
		},
		balance(state) {
			return state.balance;
		},
		jackpot(state) {
			return state.jackpot;
		},
		jackpot20M(state) {
			return state.jackpot20M;
		},
		headerHidden(state) {
			return state.headerHidden;
		},
		getCurrentTermsCategoryId(state) {
			return state.currentTermsCategoryId;
		},
		getCurrentTermsCategoryTitle(state) {
			return state.currentTermsCategoryTitle;
		},
		getCurrentTermsSubCategoryId(state) {
			return state.currentTermsSubCategoryId;
		},
		getCurrentTermsSubCategoryTitle(state) {
			return state.currentTermsSubCategoryTitle;
		},
		getCurrentTermsMiniCategoryId(state) {
			return state.currentTermsMiniCategoryId;
		},
		getCurrentTermsMiniCategoryTitle(state) {
			return state.currentTermsMiniCategoryTitle;
		},
		getLegalData(state) {
			return state.legalData;
		},
		getAndroidState(state) {
			return state.isAndroid;
		},
		getSeoContentBlock(state) {
			return state.seoContentBlock;
		},
		getMetaContentBlock(state) {
			return state.metaContentBlock;
		},
		getGA4EventConfig(state) {
			return state.ga4AnalyticsEventConfig;
		},
		utmSource: (state) => state.utmSource,
	},
});

export default store;
